import { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { enumStatuses } from '../../consts/status';
import PurchaseOrderStatusChip from '../../features/purchaseOrders/PurchaseOrderStatusChip';

export const FinanceStatusFilter = ({
    options,
    selectedOptions,
    onChange,
    testId
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    const toggleOption = (option) => {
        onChange(
            selectedOptions.includes(option)
                ? selectedOptions.filter((selected) => selected !== option)
                : [...selectedOptions, option]
        );
    };

    const active = selectedOptions.length > 0;

    return (
        <div className="relative inline-block text-left" ref={wrapperRef} data-testid={testId}>
            <button
                type="button"
                data-testid={testId ? `${testId}_open_statuses` : undefined}
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center gap-1 h-8 px-3 rounded-md text-[13px] transition-colors ${
                    active
                        ? 'bg-gray-900 text-white hover:bg-gray-800'
                        : 'border border-gray-300 bg-white text-gray-900 hover:bg-gray-50'
                }`}
            >
                Status
                {active && (
                    <span className="font-medium">
                        : {selectedOptions.length === 1 ? enumStatuses[selectedOptions[0]] : selectedOptions.length}
                    </span>
                )}
                {active ? (
                    <span
                        role="button"
                        tabIndex={0}
                        className="ml-0.5 -mr-1 p-0.5 rounded hover:bg-white/20"
                        onMouseDown={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            onChange([]);
                        }}
                        aria-label="Clear status filter"
                    >
                        <XMarkIcon className="h-3 w-3" />
                    </span>
                ) : (
                    <ChevronDownIcon className="h-3.5 w-3.5 text-gray-500" />
                )}
            </button>
            {isOpen && (
                <div className="absolute left-0 mt-1 w-44 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 py-1">
                    {options?.map((option, index) => (
                        <label
                            key={option}
                            className="flex items-center gap-2.5 px-3 py-1.5 text-sm text-gray-900 hover:bg-gray-50 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                checked={selectedOptions.includes(option)}
                                data-testid={testId ? `${testId}_checkbox_${index}` : undefined}
                                onChange={() => toggleOption(option)}
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                            />
                            <PurchaseOrderStatusChip
                                status={option}
                            />
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};
